import React, { useEffect, useState } from 'react';
import './css/Servicecomp.css';
import demoLogo from '../assets/logo.png';
import { getProducts } from '../api/products';
import AnimateInView from './AnimateInView';
import { useNavigate } from 'react-router-dom';
import { demoProducts } from '../data/demoProducts';

const Servicecomp = () => {
    const [products, setProducts] = useState(demoProducts.slice(0, 4));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedServiceId, setExpandedServiceId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                const response = await fetch('https://www.dhimanwoodworks.com/api/products');
                
                if (!response || !response.data) {
                    throw new Error('No data received');
                }

                const fetchedProducts = response.data.products || response.data;
                
                const validProducts = fetchedProducts.filter(product =>
                    product &&
                    product.image?.url &&
                    product.title &&
                    product.description
                );

                // Combine fetched products with demo products if needed
                if (validProducts.length < 4) {
                    const remainingCount = 4 - validProducts.length;
                    const combinedProducts = [
                        ...validProducts,
                        ...demoProducts.slice(0, remainingCount)
                    ];
                    setProducts(combinedProducts);
                } else {
                    setProducts(validProducts.slice(0, 4));
                }
                setError(null);
            } catch (error) {
                console.error('Error fetching products:', error);
                setProducts(demoProducts.slice(0, 4));
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const logos = Array(5).fill({ logo: demoLogo }).map((item, index) => ({
        id: index + 1,
        logo: item.logo
    }));

    const handleToggleDescription = (id) => {
        navigate("/services");
    };

    const renderServiceItem = (service, index) => (
        <div
            key={service._id || service.id}
            className='service-item2'
            style={{
                borderRight: index !== 3 ? '1px solid var(--border-color)' : 'none'
            }}
        >
            <div className='service-item-content'>
                <img
                    src={logos[index]?.logo}
                    alt={service?.title}
                    className='service-logo'
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = demoLogo;
                    }}
                />
                <div className='service-image-container'>
                    <img
                        src={service?.image?.url}
                        alt={service?.title}
                        className='service-bg-image'
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = demoLogo;
                        }}
                    />
                </div>
                <div className='service-hover-content'>
                    <h3>{service.title}</h3>
                    <p>
                        {expandedServiceId === service?.id
                            ? service?.description
                            : service?.description?.length > 150
                                ? `${service.description?.slice(0, 150)}...`
                                : service?.description}
                    </p>
                    {service?.description?.length > 150 && (
                        <button
                            style={{border: "none", background: "none", cursor: "pointer"}}
                            className='see-more-btn'
                            onClick={() => handleToggleDescription(service?.id)}
                        >
                            {expandedServiceId === service.id ? 'See Less' : 'See More...'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <section className='hero-container-div1'>
            <AnimateInView delay={0.2}>
                <div className='service-container-main'>
                    <div className='service-heading-div'>
                        <h1 className='heading-large color-service-heading'>Our Services</h1>
                    </div>
                    <div className='service-container-main-content1'>
                        <p className='paragraph-service'>
                            Dhiman Wood Work is a renowned provider of premium wooden craftsmanship services.
                            We specialize in custom wood furniture, commercial woodwork, and wood restoration.
                            Our experienced artisans bring passion and precision to every project.
                        </p>
                        <div className='service-round-div'>
                            <p className='round-para-service'>Get Expert Woodwork Solutions Today!</p>
                        </div>
                    </div>

                    {loading && (
                        <div className="loading-services">Loading services...</div>
                    )}

                    {!loading && (
                        <div className='mapservices-content-div'>
                            {products.map((service, index) =>
                                renderServiceItem(service, index)
                            )}
                        </div>
                    )}
                </div>
            </AnimateInView>
        </section>
    );
};

export default Servicecomp;
